import classNames from "classnames";
import { getVocabulary } from "components/Vocabulary";
import { capitalize, isNil } from "lodash";
import React from "react";

import "./index.less";

export default function ACSeverityTag({
  value,
  className,
  isCustomizedValue = true,
  customValue,
  style,
}: Props) {
  const displayValue = isCustomizedValue
    ? !isNil(customValue)
      ? customValue
      : getVocabulary(value)
    : capitalize(value);
  return value || customValue ? (
    <div
      className={classNames(
        `ac-severity-tag ac-severity-${value.toLowerCase()} ${className}`,
      )}
      style={style}
    >
      <div
        className="text-ellipsis"
        title={isCustomizedValue ? getVocabulary(value) : capitalize(value)}
      >
        {displayValue}
      </div>
    </div>
  ) : null;
}

interface Props {
  value: SeverityType;
  className?: string;
  isCustomizedValue?: boolean;
  customValue?: React.ReactNode;
  style?: React.CSSProperties;
}

export type SeverityType =
  | "critical"
  | "Critical"
  | "CRITICAL"
  | "high"
  | "High"
  | "HIGH"
  | "medium"
  | "Medium"
  | "MEDIUM"
  | "low"
  | "Low"
  | "LOW"
  | "info"
  | "Info"
  | "INFO";
